import React from "react";
import {SSNField, TextFieldProps} from "@reside/ui";
import {Form} from "antd";

import {LabelAttribute} from "../label-attribute";
import {DisabledAttribute} from "../disabled-attribute";
import {RequiredAttribute} from "../required-attribute";
import {AtomProp, useFocusedNode} from "../../model/editor";
import {DisableClick} from "../disable-click";
import {FormControlSourceNode} from "../../model/schemaTypes";

export const EditableSSNField = ({
  atom,
  ...props
}: TextFieldProps & AtomProp) => (
  <DisableClick>
    <SSNField {...props} />
  </DisableClick>
);

/**
 * FormControl type-specific form to adjust attributes.
 */
export const SSNFieldForm = () => {
  const node = useFocusedNode() as FormControlSourceNode;

  return (
    <Form
      key={node.id}
      initialValues={{
        label: node?.reference?.translationKey,
      }}
    >
      <LabelAttribute />
      <DisabledAttribute />
      <RequiredAttribute />
    </Form>
  );
};
